import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment.development';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';
import { BehaviorSubject, Observable, tap, catchError } from 'rxjs';
import {
  ApiResponse,
  QueryParams,
  Subscription,
  SubscriptionApiResponsePaginated,
} from '../subscriptions/subscription.inteface';
@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private readonly API_URL = `${environment.apiUrl}/Subscription`;
  private readonly http = inject(HttpClient);
  private readonly errorHandler = inject(ErrorHandlingService);
  private organizationsSubscriptionSubject =
    new BehaviorSubject<SubscriptionApiResponsePaginated | null>(null);
  subscription$ = this.organizationsSubscriptionSubject.asObservable();

  getSubscriptions(
    queryParams: QueryParams
  ): Observable<SubscriptionApiResponsePaginated> {
    return this.http
      .get<SubscriptionApiResponsePaginated>(`${this.API_URL}/list`, {
        params: this.buildQueryParams(queryParams),
      })
      .pipe(
        tap(response => this.organizationsSubscriptionSubject.next(response)),
        catchError(error => this.errorHandler.handleError(error))
      );
  }
  private buildQueryParams({
    pageIndex,
    pageSize,
    sortOrder,
    sort,
    searchTerm,
    organizationId,
  }: QueryParams): HttpParams {
    let params = new HttpParams()
      .set('Page', pageIndex.toString())
      .set('PageSize', pageSize.toString());

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (sort) {
      params = params.set('sort', sort);
    }

    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }

    if (organizationId) {
      params = params.set('organizationId', organizationId.toString());
    }

    return params;
  }
  createSubscription(
    payload: Subscription
  ): Observable<ApiResponse<Subscription>> {
    return this.http
      .post<ApiResponse<Subscription>>(`${this.API_URL}/create`, payload)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updateSubScription(
    payload: Subscription
  ): Observable<ApiResponse<Subscription>> {
    const params = new HttpParams().set('id', payload.id.toString());
    return this.http
      .put<
        ApiResponse<Subscription>
      >(`${this.API_URL}/update`, payload, { params })
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  deleteSubscription(id: number): Observable<ApiResponse<void>> {
    return this.http
      .delete<ApiResponse<void>>(`${this.API_URL}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
